/**
 *
 * @component 用户中心/我的消息/管家中心/发送消息组件
 *
 **/

import { memo, useEffect, useState, useRef } from 'react';
import { getUsers, sendMessage } from '@/api/personCenter/message';
import {
    Form,
    Input,
    Radio,
    Tree,
    Button,
    Popover,
    message,
    Empty,
} from 'antd';
import { driver } from 'driver.js';
import quickStartGuide from '&/store/quickStartGuide';
import { useStoreState } from '&/utils/customHooks';
import 'driver.js/dist/driver.css';
import './PostMessage.scss';

function PostMessage(props) {
    const { onSended } = props;
    const [formRef] = Form.useForm();
    const { Item } = Form;

    const buttonRef = useRef();

    const radioOptions = [
        {
            label: intl.get('message.steward.byDepartment'),
            value: 1,
            title: intl.get('message.steward.selectDepartment'),
        },
        {
            label: intl.get('message.steward.byProject'),
            value: 2,
            title: intl.get('message.steward.selectProject'),
        },
        {
            label: intl.get('message.steward.byRole'),
            value: 3,
            title: intl.get('message.steward.selectRole'),
        },
    ];

    const [useList, setUseList] = useState([]);

    const queryUsers = dop => {
        return getUsers({ dop }).then(({ data }) => {
            data = data || [];
            setUseList(
                data
                    .filter(el => !!el.son.length)
                    .map(el => {
                        const { son } = el;

                        if (+dop === 1) {
                            // 带部门，三层
                            el.children = son.map(cel => {
                                cel.children = cel.son.map(ccel => ({
                                    key: `${cel.id}-${ccel.userId}`,
                                    title: ccel.userName,
                                }));
                                cel.key = +cel.id;
                                cel.title = cel.name;
                                return cel;
                            });
                        } else {
                            el.children = son.map(cel => ({
                                key: `${el.id}-${cel.userId}`,
                                title:
                                    +dop === 2 ? (
                                        <>
                                            {cel.username}
                                            <span className="role-name">
                                                {cel.roleName}
                                            </span>
                                        </>
                                    ) : (
                                        cel.username
                                    ),
                            }));
                        }

                        el.key = +el.id;
                        el.title = el.name;
                        return el;
                    })
            );
        });
    };

    const [checkedKeys, setCheckedKeys] = useState([]);

    const onCheck = checkedKeysValue => {
        setCheckedKeys(checkedKeysValue);
    };

    const clearTree = e => {
        e.stopPropagation();
        setCheckedKeys([]);
    };

    const treeEl = useList.length ? (
        <Tree
            checkable
            selectable={false}
            onCheck={onCheck}
            treeData={useList}
            checkedKeys={checkedKeys}
        />
    ) : (
        <Empty className="opt-empty" image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );

    const [selectUser, setSelectUser] = useState([]);

    const first = useRef(true);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        formRef.validateFields(['users']);
    }, [selectUser.length]);

    useEffect(() => {
        let arr = checkedKeys
            .filter(e => typeof e === 'string')
            .map(e => e.split('-')[1]);

        setSelectUser([...new Set(arr)]);
    }, [checkedKeys]);

    const onFieldsChange = ([changedField]) => {
        if (changedField?.name[0] === 'dop') {
            setCheckedKeys([]);
            queryUsers(changedField.value);
        }
    };

    useEffect(() => {
        let driverObj = null;
        queryUsers(1).then(() => {
            quickStartGuide
                .queryGuidance('entMessageTemp')
                .then(examineTempPopup => {
                    if (+examineTempPopup !== 0) return;
                    if (!buttonRef.current) return;
                    driverObj = driver({
                        disableActiveInteraction: true,
                        allowClose: false,
                        steps: [
                            {
                                element: buttonRef.current,
                                popover: {
                                    title: intl.get(
                                        'quickStartGuidance.messageTemp.title'
                                    ),
                                    description: intl.get(
                                        'quickStartGuidance.messageTemp.description'
                                    ),
                                    side: 'bottom',
                                    align: 'center',
                                    doneBtnText: intl.get(
                                        'quickStartGuidance.button.done'
                                    ),
                                    onPopoverRender: dom => {
                                        const { previousButton } = dom;
                                        previousButton.style.display = 'none';
                                    },
                                    onNextClick: () => {
                                        quickStartGuide.setGuidanceStatus(
                                            'entMessageTemp',
                                            2
                                        );
                                        driverObj.destroy();
                                    },
                                },
                            },
                        ],
                    });
                    driverObj.drive();
                });
        });
        return () => {
            if (driverObj) {
                driverObj.destroy();
                driverObj = null;
            }
        };
    }, []);

    const sendItem = (
        <Item
            required
            label={intl.get('message.steward.send')}
            className="select-group"
            shouldUpdate
            name="users"
            rules={[
                () => ({
                    validator(_, value) {
                        if (selectUser.length > 0) {
                            return Promise.resolve();
                        }
                        return Promise.reject(
                            new Error(intl.get('message.steward.selecteHint'))
                        );
                    },
                }),
            ]}>
            <Item noStyle>
                <Item noStyle name="dop" initialValue={1}>
                    <Radio.Group options={radioOptions} />
                </Item>

                <div className="select-users">
                    {
                        radioOptions[(formRef.getFieldValue('dop') || 1) - 1]
                            .title
                    }
                    <Item noStyle>
                        <Popover
                            content={treeEl}
                            placement="bottomLeft"
                            getPopupContainer={() =>
                                document.querySelector('.post-message')
                            }
                            trigger={['click']}>
                            <div className="select-el">
                                {!selectUser.length ? (
                                    <span className="select-el-placeholder">
                                        {intl.get(
                                            'message.steward.pleaseSelect'
                                        )}
                                    </span>
                                ) : (
                                    <span className="select-el-tag">
                                        {intl.get(
                                            'message.steward.selectedCount',
                                            { count: selectUser.length }
                                        )}
                                    </span>
                                )}
                                <i className="icon-caret-down filled down-icon" />
                                <i
                                    className="icon-close-cirlcle1 filled clear-icon"
                                    onClick={clearTree}
                                />
                            </div>
                        </Popover>
                    </Item>
                </div>
            </Item>
        </Item>
    );

    const [sendLoading, setSendLoading] = useState(false);

    const onFinish = values => {
        setSendLoading(true);
        sendMessage(Object.assign(values, { users: selectUser }))
            .then(({ msg }) => {
                message.success(msg);
                onSended();
                setSelectUser([]);
                setCheckedKeys([]);
                formRef.resetFields();
            })
            .finally(() => {
                setSendLoading(false);
            });
    };

    const { organization = {} } = useStoreState('appStore');
    const disabled =
        organization.example === 0 &&
        !['admin', 'housekeeper'].includes(organization.roleFlag);

    return (
        <div className="post-message">
            <Form
                form={formRef}
                onFinish={onFinish}
                labelCol={{ span: 3 }}
                onFieldsChange={onFieldsChange}>
                <Item
                    label={intl.get('message.steward.title')}
                    name="title"
                    rules={[{ required: true }]}>
                    <Input
                        placeholder={intl.get('message.steward.pleaseInput')}
                        allowClear
                        maxLength={50}></Input>
                </Item>
                {sendItem}
                <Item
                    label={intl.get('message.steward.content')}
                    name="content"
                    rules={[{ required: true }]}>
                    <Input.TextArea
                        maxLength={500}
                        autoSize={{
                            minRows: 4,
                            maxRows: 6,
                        }}
                        allowClear
                        showCount
                        placeholder={intl.get(
                            'message.steward.pleaseInput'
                        )}></Input.TextArea>
                </Item>
                <Item wrapperCol={{ offset: 3 }} className="btn-wrap">
                    <Button
                        ref={buttonRef}
                        type="primary"
                        disabled={disabled}
                        loading={sendLoading}
                        onClick={formRef.submit}>
                        {intl.get('message.steward.sendMessage')}
                    </Button>
                </Item>
            </Form>
        </div>
    );
}

export default memo(PostMessage);
